var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group row toelichting1",attrs:{"for":_vm.item.id}},[_c('div',{class:_vm.className,domProps:{"innerHTML":_vm._s(_vm.naamTranslated)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }